import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';

import { SettingsService } from '@app/core/auth';
import { ChannelService } from '@app/core/channels/services/channel.service';
import { RfqService } from '@app/core/quotes';
import { ShippingCarrierService } from '@app/core/shipping-carriers/services/shipping-carrier.service';
import { trimWala } from '@app/shared/utils/string.utils';

@Component({
  selector: 'cnc-channel-shipping',
  templateUrl: './channel-shipping.component.html',
  styleUrls: ['./channel-shipping.component.scss'],
})
export class ChannelShippingComponent implements OnInit, OnDestroy {
  constructor(
    private rfqSvc :RfqService,
    private channelSvc :ChannelService,
    public carrierSvc :ShippingCarrierService,
    private settingsSvc :SettingsService,
    private cd :ChangeDetectorRef,
    private toastr :ToastrService,
  ) {}

  params :any = {
    per_page: 20,
    page: 1,
  };

  pageSizeOptions :number[] = [5, 10, 25, 100];

  records :any = { data: [] };

  rfqs :any[] = [];
  channels :any;
  page = 1;
  pageSize = 20;
  filter :any = {};
  settings :any;

  loadingRfqs :number = 3;
  channelSub :Subscription;
  settingSub :Subscription;
  rfqSub :Subscription;

  gettingRecords$ :Observable<boolean>;
  shippingCarriers$ :Observable<any>;

  ngOnInit() {
    this.channelSvc.get({ all: 1 });

    this.getRecords();

    this.settingSub = this.settingsSvc.settings$.subscribe((settings :any) => {
      this.settings = settings;
      this.loadingRfqs -= 1;
      this.setRfqs();
    });

    this.channelSub = this.channelSvc.channels$.subscribe((channels) => {
      this.loadingRfqs -= 1;
      if (channels && channels.length > 0) {
        this.channels = channels;
        this.channels = channels.map((channel) => {
          return { id: channel.id, label: channel.label, price: 0 };
        });
        this.setRfqs();
      }
    });

    this.rfqSub = this.rfqSvc.record_channel_shipping$.subscribe((records) => {
      this.records = records;
      this.setRfqs();
      this.cd.detectChanges();
    });

    this.getDataFromService();
  }

  ngOnDestroy() {
    this.channelSub.unsubscribe();
    this.settingSub.unsubscribe();
    this.rfqSub.unsubscribe();
  }

  updateChannelShipping(rfq :any, channel :any) {
    const payload :any = {
      rfq_id: rfq.id,
      channel_id: channel.id,
      shipping_carrier_id: channel.shipping_carrier_id,
    };
    this.rfqSvc.updateChannelShipping(payload).subscribe(
      (resp) => {
        this.toastr.success('Channel shipping updated.');
      },
      (error) => {
        this.toastr.error(
          'Error saving. Please try again later or contact support.',
        );
      },
    );
  }

  getRecords(event ?:any, page ?:number) {
    if (page) {
      this.params.page = page;
    }

    this.params = Object.assign(this.params, this.filter);

    if (this.params.order) {
      this.params.order = trimWala(this.params.order, '-');
    }

    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }

    this.rfqSvc.getChannelShipping(this.params);
  }

  setRfqs() {
    if (!this.channels || !this.settings) {
      return;
    }
    if (!this.records.data || this.records.data.length == 0) {
      return;
    }

    this.records.data.forEach((rfq :any) => {
      rfq.channels = JSON.parse(JSON.stringify(this.channels));
      rfq.channels.forEach((channel :any) => {
        if (rfq.channel_shipping && rfq.channel_shipping.length > 0) {
          const shipping = rfq.channel_shipping.find(
            (row) => row.channel_id == channel.id,
          );
          if (shipping && shipping.id) {
            channel.shipping_carrier_id = shipping.shipping_carrier_id;
          } else if (rfq.default_shipping && rfq.default_shipping > 0) {
            channel.shipping_carrier_id = rfq.default_shipping;
          } else if (
            this.settings &&
            this.settings.default_shipping &&
            this.settings.default_shipping > 0
          ) {
            channel.shipping_carrier_id = this.settings.default_shipping;
          }
        }
      });
      this.cd.detectChanges();
    });
  }

  private getDataFromService() :void {
    this.gettingRecords$ = this.rfqSvc.gettingRecords$;
    this.shippingCarriers$ = this.carrierSvc.shippingCarriers$;
  }
}
